import { Icon, IconProps } from './Icon';

export type FolderPlusProps = IconProps;

export const FolderPlus = (props: FolderPlusProps) => (
  <Icon width="20px" height="20px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="m10.833 5.833-.93-1.859c-.267-.535-.4-.803-.6-.998a1.667 1.667 0 0 0-.623-.385C8.416 2.5 8.117 2.5 7.52 2.5H4.333c-.933 0-1.4 0-1.756.182-.314.16-.569.414-.729.728-.181.357-.181.823-.181 1.757v.666m0 0h12.666c1.4 0 2.1 0 2.635.273a2.5 2.5 0 0 1 1.093 1.092c.272.535.272 1.235.272 2.635V13.5c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.092c-.535.273-1.235.273-2.635.273H5.667c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635V5.833ZM10 14.167v-5m-2.5 2.5h5" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
